import { WorkspaceEvaluationContext } from "../../WorkspaceEvaluationContext"
import WorkspaceEvaluateResponse from "../WorkspaceEvaluateResponse"

/** The resolved whole-workspace evaluation: the cached context to store. */
export class FullWorkspaceEvaluateResponse implements WorkspaceEvaluateResponse {
  constructor(readonly context: WorkspaceEvaluationContext) {}

  get evaluation() {
    return this.context.workspace
  }
}
